var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lazy-background',{staticClass:"hero",attrs:{"src":(_vm.image)?_vm.image.thumbs.thumb1920:null}},[_c('h1',[_vm._v(_vm._s(_vm.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }